import React, { useEffect, useState } from "react";
import { Button, Spin } from "antd";
import SlaUpdateModal from "../components/sla/SlaUpdateModel";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  getSlaContent,
  getSlaContentRequest,
} from "@src/redux";
import { useTranslation } from "react-i18next";
import { useCheckPageComponentAccess } from "@src/hooks/index";

const SLA: React.FC = () => {
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();
  const { result: getSlaResult, loading: getSlaLoading } =
    useSelector(getSlaContent);

  const handleUpdate = () => {
    setShowUpdateModal(true);
  };

  const handleCancel = () => {
    setShowUpdateModal(false);
  };

  useEffect(() => {
    dispatch(getSlaContentRequest({}));
  }, [dispatch]);

  return (
    <div style={{ height: "100vh" }}>
      <div className="sla_header">
        <div className="sla_content_title">
          <h2>{t("sla_content")}</h2>
        </div>
        {useCheckPageComponentAccess("update_sla_action") && (
          <div className="update_sla_button">
            <Button onClick={handleUpdate}>{t("update")}</Button>
          </div>
        )}
      </div>

      {getSlaLoading ? (
        <div style={{ textAlign: "center", paddingTop: "20px" }}>
          <Spin size="large" />
        </div>
      ) : (
        <iframe
          src={getSlaResult?.url}
          title="SLA Document"
          width="100%"
          height="100%"
          className="iframe_sla"
        />
      )}

      <SlaUpdateModal visible={showUpdateModal} onCancel={handleCancel} />
    </div>
  );
};

export default SLA;
